import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La Muŝoj estas ardaj mod-adorantinoj. 
      Ili haltas ĉe ajna peco de bela aĴura araneaĴo, pritaksas ĝin, aprobas kaj ravite demandas ĉe bonkoraspekta dikulo Araneo:
    </p>
    
    <p class="mb-3">
      - Kiom kostas milimetro?
    </p>
    
    <p class="mb-3">
      Kaj kutime ili pagas la plej altan prezon.
    </p>
    `
  )
}

const itemName = {
  esp: 'Mod-adorantinoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;